import { useScreen, useGrid } from 'vue-screen'

const screen = useScreen()
const grid = useGrid('tailwind')
const isMobile = () => {
	const match = window.matchMedia
	if (!match) return false
	const device = match('(pointer:coarse)')
	return device.matches
}

export const useAppScreen = () => ({ screen, grid, isMobile })
